import classNames from 'classnames';
import React, { useEffect, useState } from 'react';

type Props = {
  name: string;
  label: string;
  value: string;
  checked: boolean;
  showTapAnimation: boolean;
  onChange: (value: string) => void;
  className?: string;
};

export const StyledRadio: React.FC<Props> = ({
  label,
  name,
  onChange,
  checked,
  value,
  className,
}) => {
  const classes = classNames('radio', { 'radio--checked': checked }, className);

  return (
    <label className={classes}>
      <span className='radio__input'>
        <input
          type='radio'
          name={name}
          value={value}
          onChange={() => onChange(value)}
          checked={checked}
        />
        <span className='radio__control' />
      </span>
      <span className='radio__label'>{label}</span>
    </label>
  );
};
